import { render } from "./Verpflegung.vue?vue&type=template&id=c9637c58&scoped=true"
import script from "./Verpflegung.vue?vue&type=script&lang=js"
export * from "./Verpflegung.vue?vue&type=script&lang=js"

import "./Verpflegung.vue?vue&type=style&index=0&id=c9637c58&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/drk-hurricane.de/test-helfer.drk-hurricane.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9637c58"]])

export default __exports__